$.fn.overLay = function(){
  	var wrapper = $('<div id ="modal_overlay_img" style="text-align: center; position: fixed;top: 50%;left: 50%;margin:-25px 0 0 -25px; display: block;"><img src="'+ constraint.commonCdnPath +'/common/images/img_loading.svg" alt="loading" class="loadImg" height="50" width="50"></div>');
  	var overlay = $('<div id="modal_overlay" style="background-color: rgba(0, 0, 0, 0.701961); display: block;"></div>');
	$('body').append(overlay);
	$('body').append(wrapper);
}
$.fn.hideOverLay = function(){
	$('#modal_overlay_img').remove();
	$('#modal_overlay').remove();
}

$(function(){

	$(".productInfo_image .preview").on("touchend click",function(){
		$(".productInfo_image .preview").removeClass('current');
		$(this).addClass('current');
		$("#mainImage").attr("src", $(this).find("img").attr("src"));
	});
	
	$('#searchResult_num').on('change', function(){
		$.fn.overLay();
		location.href=$('#searchResult_num').data('url') + '?l=' + $(this).val() ;
	});
	
	$(".more_models").on("click touch", function(){
		$.fn.overLay();
		var captureThis = this;
		var offset = $(this).data('next_offset');
		var limit = $(this).data('limit');
		var from = offset * limit;
		var url= location.protocol + "//" + location.host + "/r/d/s/more/" + $('#searchResult_num').data('id') +
		         "/?limit=" + limit +
		         "&offset=" + from +
		         "&itemColumnView=" + $('#itemColumnView').val();
		 $.ajax({
			   type: "GET",
			   url: url,
			   dataType: 'json',
			   success: function(msg){
				   if(!msg || msg.errors.message || msg.errors.messages.length > 0 || !msg.data) {
					   $().hideOverLay();
					   return ;
				   }
				   $(".js_modelTablePC").append(msg.data.pcView);
				   $(".js_modelTableTB").append(msg.data.tbView);

				   var count = parseInt($(".model_display_count").html());
				   count += msg.data.listCount;
				   $(".model_display_count").html(count);
				   
				   $(captureThis).data('next_offset', (offset +1));
				   if(msg.data.totalCount <= $(".models_row").length) {
					   $(captureThis).remove();
				   }
				   $().hideOverLay();
			   },
			   error: function(XMLHttpRequest, textStatus, errorThrown) {
				   $().hideOverLay();
			   }
		 });
	});	
});